import { GenericEcard } from './GenericEcard';
export default GenericEcard;
